import { createMessageTokens } from '../tokens/components.js';
import { SEMANTIC, type SemanticTokens } from '../tokens/semantic.js';

/**
 * Toast Component Configuration
 */
export function createToast(s: SemanticTokens) {
  const messageTokens = createMessageTokens(s);
  return {
    root: {
      width: messageTokens.base.width,
      borderRadius: messageTokens.base.radius,
      borderWidth: '0 0 0 4px',
      transitionDuration: messageTokens.base.transitionDuration,
      blur: messageTokens.base.blur,
    },
    content: {
      padding: `${messageTokens.base.paddingY} ${messageTokens.base.paddingX}`,
      gap: messageTokens.base.gap,
    },
    text: {
      gap: messageTokens.base.gap,
    },
    summary: {
      fontWeight: messageTokens.base.titleFontWeight,
      fontSize: messageTokens.base.titleFontSize,
    },
    detail: {
      fontWeight: messageTokens.base.bodyFontWeight,
      fontSize: messageTokens.base.bodyFontSize,
    },
    icon: {
      size: messageTokens.base.toastIconSize,
    },
    closeButton: {
      width: messageTokens.base.closeButtonSize,
      height: messageTokens.base.closeButtonSize,
      borderRadius: messageTokens.base.closeButtonRadius,
    },
    closeIcon: {
      size: messageTokens.base.closeIconSize,
    },
    colorScheme: {
      light: {
        success: {
          background: messageTokens.success.bg,
          borderColor: messageTokens.success.border,
          color: messageTokens.success.fg,
          detailColor: messageTokens.success.fg,
          shadow: messageTokens.base.shadow,
        },
        info: {
          background: messageTokens.info.bg,
          borderColor: messageTokens.info.fg,
          color: messageTokens.info.fg,
          detailColor: messageTokens.info.fg,
          shadow: messageTokens.base.shadow,
        },
        warn: {
          background: messageTokens.warning.bg,
          borderColor: messageTokens.warning.border,
          color: messageTokens.warning.fg,
          detailColor: messageTokens.warning.fg,
          shadow: messageTokens.base.shadow,
        },
        error: {
          background: messageTokens.danger.bg,
          borderColor: messageTokens.danger.border,
          color: messageTokens.danger.fg,
          detailColor: messageTokens.danger.fg,
          shadow: messageTokens.base.shadow,
        },
      },
    },
    css: () => `
    .p-toast-summary {
      line-height: ${messageTokens.base.summaryLineHeight};
    }
    
    .p-toast-message-content svg,
    .p-toast-message-icon {
      margin-top: 0.25rem;
    }
  `,
  };
}
export const toast = createToast(SEMANTIC);
